export class MainActionData {
	closeable = false;

	/**
	 *
	 * @param {string} name
	 * @param {string} callback - globally accessible
	 * @param {object} attributes
	 */
	constructor(name, callbackId, attributes = {}) {
		this.name = name;
		this.callbackId = callbackId;
		this.attributes = attributes;
	}

	static from({ name = "Continue", callbackId = null, attributes = {} }) {
		return new MainActionData(name, callbackId, attributes);
	}
}
